/**
 * Asynchronously loads the component for ScreenSaver
 */
import Loadable from 'ui/Loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "kiosk" */ './index'),
});
